module.exports = __webpack_public_path__ + "static/media/yopen-redefinePassword.f1891d97.svg";